import { connect } from 'react-redux';
import { compose } from 'redux';
import HandoffImage from '../../components/handoff/HandoffImage';
import { getSelectedElement } from '../../selectors/handoff';
import * as handoff from '../../utils/handoff/element';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return {
        type: element.className,
        url: handoff.getElementThumbURL(element),
    };
}
export default compose(connect(mapStateToProps))(HandoffImage);
